module.exports = __webpack_public_path__ + "static/img/720409.30c60fa.30c60fa7.jpg";